import Typography from './Typography';
import H3 from './h3';

export default Typography;
export { H3 };
